import { useCallback, useState, useRef } from "react";
import { RelativeContainer, DropdownContainer, OptionsContainer } from "./styles";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import IconButton from "../IconButton";
import InlineSVG from "react-inlinesvg";
import classNames from "classnames";

export default function Dropdown({ options, selectedOption, onSelect, placeholder = "Select an Option" }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const ref = useRef(null);

  const hideDropdown = useCallback(() => {
    setShowDropdown(false);
  }, []);

  useOnClickOutside(ref, hideDropdown);

  const handleOnSelect = useCallback(
    (option) => {
      hideDropdown();
      onSelect(option);
    },
    [onSelect, hideDropdown]
  );

  return (
    <RelativeContainer ref={ref}>
      <DropdownContainer
        className="dropdown"
        onClick={() => setShowDropdown((prevState) => !prevState)}
      >
        <div className="label-wrapper">
          <p className="label-inner">{selectedOption?.label || placeholder}</p>
        </div>
        <IconButton
          size={22}
          src="/assets/down-chevron.svg"
        />
      </DropdownContainer>
      <OptionsContainer
        style={{
          maxHeight: !showDropdown ? 0 : "calc(-205px + 100vh)",
          opacity: showDropdown ? 1 : 0,
        }}
      >
        {options.map((option, i) => (
          <li
            key={option.value}
            className="option-item"
          >
            <OptionsButton
              onClick={handleOnSelect}
              selected={option.value === selectedOption?.value}
              option={option}
            />
          </li>
        ))}
      </OptionsContainer>
    </RelativeContainer>
  );
}

const OptionsButton = ({ onClick, option, selected }) => {
  const handleOnClick = useCallback(() => {
    onClick(option);
  }, [onClick, option]);

  return (
    <button
      className={classNames("option-item-button use-component-styles", { selected, danger: option.value === null })}
      onClick={handleOnClick}
    >
      {option.icon && <InlineSVG src={option.icon} />}
      <p className={classNames({ danger: option.danger })}>{option.label}</p>
    </button>
  );
};
